define('modules/page_generator/service',['require','exports','module','modules/editor/models/variant','lib/util','./page_amp_renderer','./page_renderer'],function (require, exports, module) {
  "use strict";
  var Variant = require("modules/editor/models/variant"),
    util = require("lib/util");

  module.exports = {
    getPageRendererService: function (variantModel) {
      if (util.isVariantAMP(variantModel)) {
        return require("./page_amp_renderer");
      }

      return require("./page_renderer");
    },

    generatePage: function (variantModel) {
      var PageRenderer = this.getPageRendererService(variantModel),
        generator = new PageRenderer(variantModel);

      return generator.generateSteps();
    },

    generatePreview: function (variantModel, page) {
      var PageRenderer = this.getPageRendererService(variantModel),
        generator = new PageRenderer(variantModel);

      return generator.generatePreview(page);
    },

    //Given a pageId and optionally a variantId
    //open the preview page
    //Usage: PageGeneratorService.showPreview({pageId: 12, variantId: 1})
    showPreview: function (options) {
      options = options || {};

      if (!options.pageId) {
        throw new Error("Can't showPreview without at least a pageId to fetch the variant");
      }

      var model = new Variant({
        pages_id: options.pageId,
        id: options.variantId
      });

      model.fetch({
        success: function (model) {
          showPreviewFrom(model, options);
        },
        error: function () {
          throw new Error("Error loading variant for preview", options);
        }
      });
    },

    //Given a variantModel, open the preview page
    showPreviewFromModel: function (options) {
      var pageId = options.model ? options.model.get('pages_id') : options.get('pages_id');
      window.open("/preview/" + pageId, "_blank");
    }
  };
});

